<template>
  <div class="mb-[216px] flex flex-col justify-center md:mb-[224px]">
    <h3 class="heading-2 mb-24 mt-36 text-center">
      {{ i18n(translations.introAtcEnhancedAnimatedTitle) }}
    </h3>

    <RevCard class="shadow-long px-16 pb-16 pt-12">
      <RevTag
        class="bg-surface-brand-hi mb-16"
        :label="i18n(translations.introAtcEnhancedAnimatedTagText)"
        variant="primary"
      />

      <div class="flex">
        <RevIllustration
          v-if="image"
          :alt="image.description"
          class="!h-[76px] !w-[70px]"
          :height="76"
          :src="image.url"
          :width="70"
        />

        <div class="flex flex-col pl-16">
          <p v-if="productTitle" class="heading-3">{{ productTitle }}</p>
          <template v-if="priceWithoutTradeIn && price">
            <AnimatedPrice
              :end-price="price"
              :start-price="priceWithoutTradeIn"
            />
          </template>
        </div>
      </div>
    </RevCard>

    <p class="text-static-default-low caption pt-16">
      {{ i18n(translations.introAtcEnhancedAnimatedCaptionText) }}
    </p>
  </div>

  <div
    class="bg-surface-default-mid absolute bottom-0 left-0 right-0 px-24 pb-24 pt-8"
  >
    <RevButton
      data-qa="user-yes"
      data-test="user-yes"
      full-width="always"
      variant="secondary"
      @click="emit('next-step')"
    >
      <span class="flex flex-col">
        <span class="heading-3">
          {{ i18n(translations.introYesGetOfferMain) }}
        </span>

        <span class="body-2">
          {{ i18n(translations.introYesGetOfferSecondary) }}
        </span>
      </span>
    </RevButton>

    <RevButton
      class="mx-auto mt-16 block"
      data-qa="user-no"
      data-test="user-no"
      full-width="always"
      variant="secondary"
      @click="emit('close')"
    >
      <span class="flex flex-col">
        <span class="heading-3">
          {{ i18n(translations.introNoRefuseOfferMain) }}
        </span>

        <span class="body-2">
          {{ i18n(translations.introNoRefuseOfferSecondary) }}
        </span>
      </span>
    </RevButton>
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'

import AnimatedPrice from './AnimatedPrice.vue'
import translations from './Intro.translations'

interface IntroAtcProps {
  price?: Price
  priceWithoutTradeIn?: Price
  closeWording: string
  image?: GetProductResponse['images'][number]
  productTitle?: string
}

defineProps<IntroAtcProps>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'next-step'): void
}>()

const i18n = useI18n()
</script>
